import {IAttribute} from './i-attribute';

export class Attribute {
    public constructor(public code: string,
                       public reference: string,
                       public descripion: string) {
    }

    public static fromInterface(iAttribute: IAttribute): Attribute {
        return new Attribute(
			iAttribute.code,
			iAttribute.reference,
			iAttribute.description
        );
    }
}
